export default __webpack_public_path__ + "static/media/nav-utensils-white.38ef0e24.svg";